<template>
  <el-dialog title="导出当前会话快照" :visible.sync="visible" width="480px" append-to-body :close-on-click-modal="!exporting">
    <p>导出当前查询结果，每辆车单独成表；失败车辆保留失败原因。</p>
    <el-radio-group v-model="addressMode"><el-radio label="NONE">现有地址</el-radio><el-radio label="PARKING">仅解析停车</el-radio><el-radio label="ALL">解析全部</el-radio></el-radio-group>
    <p v-if="progress">{{ progress }}</p>
    <span slot="footer"><el-button v-if="exporting" @click="canceled = true">取消地址解析</el-button><el-button v-else @click="visible = false">关闭</el-button><el-button type="primary" :loading="exporting" @click="download">生成XLSX</el-button></span>
  </el-dialog>
</template>
<script>
import { hasPermission } from '@/utils/auth'
import { buildVehicleExportSnapshot, resolveSnapshotAddresses } from '@/views/vehicle-monitor/vehicleMonitoringExport'
import { exportVehicleTracks } from '@/views/vehicle-monitor/vehicleMonitoringApi'
import { resolveAddressByCoord, getGlobalCoordAddressCache, normalizeCoordKey, isValidResolvedAddress } from '@/utils/coordAddressResolver'
import coordtransform from '@/WGS84'
import { saveAs } from 'file-saver'
export default {
  name: 'NativeTrackExport',
  props: { items: { type: Array, default: () => [] }, options: { type: Object, default: () => ({}) } },
  data() { return { visible: false, exporting: false, canceled: false, progress: '', addressMode: 'NONE' } },
  beforeDestroy() { this.canceled = true },
  methods: {
    open() { if (hasPermission('truck:track') && hasPermission('truck:export')) this.visible = true; else this.$message.warning('没有轨迹导出权限') },
    async resolveAddress(lon, lat) { const gcj = coordtransform.wgs84togcj02(Number(lon), Number(lat)); return resolveAddressByCoord(gcj[0], gcj[1]) },
    async download() {
      if (this.exporting || !hasPermission('truck:track') || !hasPermission('truck:export')) return
      this.exporting = true; this.canceled = false; this.progress = ''
      try {
        const snapshot = buildVehicleExportSnapshot(this.items, { ...this.options, addressMode: this.addressMode })
        snapshot.vehicles.forEach(vehicle => [...vehicle.points, ...vehicle.parkings].forEach(point => {
          if (point.address && point.address !== '未解析') return
          const gcj = coordtransform.wgs84togcj02(Number(point.longitude), Number(point.latitude))
          const cached = getGlobalCoordAddressCache().get(normalizeCoordKey(gcj[0], gcj[1]))
          if (isValidResolvedAddress(cached)) point.address = cached
        }))
        const result = await resolveSnapshotAddresses(snapshot, this.resolveAddress, () => this.canceled, (done, total) => { this.progress = `地址解析 ${done}/${total}` })
        if (this.canceled) return
        const blob = await exportVehicleTracks(snapshot)
        if (this.canceled) return
        saveAs(blob, '货车轨迹会话快照.xlsx'); this.progress = `导出完成，${result.unresolved} 条地址未解析`; this.$message.success(this.progress)
      } catch (error) { this.$message.error(error.message || error.msg) }
      finally { this.exporting = false }
    }
  }
}
</script>
